import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import ApexCharts from 'apexcharts';

@Component({
    selector: 'pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    standalone: false
})

export class PieChartComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() page = 'analytics';
  @Input() id = '';

  options = {
    series: [],
    chart: { type: 'pie', width: 400 },
    labels: [],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 100
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  chart;

  constructor() {
  }

  ngOnInit() {
    if (this.page === 'analytics') {
      this.renderChart();
    }
    if (this.page === 'feedback') {
      const labels = {};
      if (this.data && this.data.answers) {
        for (let i = 0; i < this.data.answers.length; i++) {
          labels[this.data.answers[i]] = 0;
        }
      }
      if (this.data && this.data.data) {
        for (let i = 0; i < this.data.data.length; i++) {
          const answer = this.data.data[i];
          if (answer && answer.length) {
            for (let a = 0; a < answer.length; a++) {
              labels[answer[a]] = +labels[answer[a]] + 1;
            }
          }
        }
      }
      for (const key of Object.keys(labels)) {
        this.options.labels.push(key);
        this.options.series.push(labels[key]);
      }
      setTimeout(() => {
        if (document.querySelector('#pie-chart_' + this.id)) {
          this.chart = new ApexCharts(document.querySelector('#pie-chart_' + this.id), this.options);
          this.chart.render();
        }
      })
    }
  }

  renderChart() {
    for (const element of this.data) {
      this.options.series.push(element.count);
      this.options.labels.push(element.name);
    }
    this.chart = new ApexCharts(document.querySelector('#pie-chart_' + this.id), this.options);
    this.chart.render()
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
